import React, { useEffect, useState } from "react";
import DateSelect from "../utils/DateSelect";
import PointsSelect from "../utils/PointsSelect";
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { fetchUsersByRole } from "../../action/user";
import { defaultPlatforms, roleId } from "../../constants/app";
import { fetchFilials, fetchSources } from "../../action/handbook";
import { fetchWorkingShiftByArticle, fetchReportInvoices, fetchReportRevenue, setReportsFilters } from "../../action";
import moment from "moment";
import ErrorContainer from "../utils/ErrorContainer";
import Loader from "../utils/Loader";
import SortButton from "../utils/SortButton";
import { formatNumberWithSpaces, parseNumToFixed } from "../../utils/common";
import { utils, writeFileXLSX } from "xlsx";
import MultiSelect from "../utils/MultiSelect";
import { fetchSettings } from "../../action/app";

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

const detailOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'День', value: 'day', notRender: [ 'year' ]},
    { label: 'Неделя', value: 'week', notRender: [ 'day', 'week' ]},
    { label: 'Месяц', value: 'month', notRender: [ 'day', 'week' ]},
];

const calculatePercentInvoice = (revenue, invoice) => {
    if (!revenue || !invoice || revenue === 0 || invoice === 0) return 0;
    return parseNumToFixed((invoice / revenue) * 100)
}

function DetailRow ({item, color='#d5d4ff61', marginLeft = '0px' }) {
    return (
        <>
        <tr className='kt-datatable__row' style={{ backgroundColor: color }}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={{ marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.invoiceSum) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{(item.invoicePersent || 0) + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{(item.clearSumPersent || 0) + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.clearSum) || 0}</span></td>
        </tr>
        </>
    )
}

function ResultRow ({items}) {
    const result = Object.values(items).reduce((acc, item) => {
        acc.totalSum += item.totalSum || 0;
        acc.invoiceSum += item.invoiceSum || 0;
        acc.clearSum += item.clearSum || 0;
        return acc;
    }, { totalSum: 0, invoiceSum: 0, clearSum: 0 });

    const invoicePersent = calculatePercentInvoice(result.totalSum, result.invoiceSum);
    const clearSumPersent = calculatePercentInvoice(result.clearSum, result.invoiceSum);
    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>ИТОГО</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.invoiceSum) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{(invoicePersent || 0) + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.totalSum) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{(clearSumPersent || 0) + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.clearSum) || 0}</span></td>
        </tr>
    )
}

function ItemRow ({item, detail}) {
    const [ showDetail, setShowDetail ] = useState(false);
    const renderDetail = detail && detail.value !== 'none' && !isEmpty(item.orders);

    const handleClick = () => {
        if (!renderDetail) return;
        setShowDetail(!showDetail);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderDetail) ? { cursor: 'pointer' } : {}}>
            {(renderDetail) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.invoiceSum) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{(item.invoicePersent || 0) + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{(item.clearSumPersent || 0) + ' %'}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.clearSum) || 0}</span></td>
        </tr>
        {(renderDetail) && showDetail && 
            Object.entries(item.orders).map(([key, item]) => <DetailRow item={item} marginLeft='45px'/>)
        }
        </>
    )
}

const renderAdress = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

export default function Purchase() {
    const data = useSelector(state => state.reports.purchase);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const sources = useSelector(state => state.handbook.sources);
    const sourcesCount = useSelector(state => state.handbook.count.sources);
    const sourcesLoader = useSelector(state => state.loaders.sources);
    const settings = useSelector(state => state.settings.init);
    const settingsLoader = useSelector(state => state.loaders.settings);

    const { result, invoices, filters, loading, KPorogu } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'name', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);
    const [ platforms, setPlatforms] = useState(defaultPlatforms);
    const [ searchLoading, setSearchLoading ] = useState(false);
    const loader = pointLoading || sourcesLoader || settingsLoader || searchLoading;

    const dispatch = useDispatch();

    const [ detail, setDetail ] = useState({label: 'Нет', value: 'none'});

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if ((isEmpty(sources) || sources.length < sourcesCount)) await dispatch(fetchSources(true));
            if (isEmpty(settings)) await dispatch(fetchSettings());
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
        };
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            dispatch({type: 'RESET_REPORT', name: 'purchase'});
        }
    }, [dispatch]);

    useEffect(() => {
        if (!isEmpty(sources)) setPlatforms(sources);
    }, [sources]);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = new Date(e.min);
            updated.created_at_lte = new Date(e.max);
            dispatch(setReportsFilters('purchase', updated));
        }
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('purchase', updated));
    }

    const onSearch = async () => {
        setSearchLoading(true);
        const articlesCash = settings.articlesCash || {};
        const KPoroguArticle = articlesCash.kporogu;
        if (KPoroguArticle) dispatch(fetchWorkingShiftByArticle(KPoroguArticle, 'purchase', 'KPorogu'));
        await dispatch(fetchReportRevenue({}, 'purchase'));
        await dispatch(fetchReportInvoices({}, 'purchase'));
        setRenderFilters(filters);
        setSearchLoading(false);
    }

    const getDetailOptions = () => {
        const date_gte = moment(filters.created_at_gte);
        const date_lte = moment(filters.created_at_lte);
        const diff = date_lte.diff(date_gte, 'days');
        let value = null;
        if (diff === 0) value = 'day';
        if (diff === 6) value = 'week';
        if (diff > 6 && diff < 180) value = 'month';
        if (diff >= 180) value = 'year';

        return value ? detailOptions.filter((item) => !item.notRender || !item.notRender.includes(value)) : detailOptions;
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const onExport = () => {
            const data = getGroupedData();
            const isRenderDetail = detail && detail.value !== 'none' && !isEmpty(data);
    
            const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
                const { field, sort } = _sort;
                const aField = a[field || 'name'];
                const bField = b[field || 'name'];
                if (sort === 'DESC') {
                    if (typeof aField === 'string') {
                        if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                        if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                        return 0;
                    }
                    return bField - aField;  
                } else {
                    if (typeof aField === 'string') {
                        if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                        if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                        return 0;
                    }
                    return aField - bField;                                                        
                }
            }).flatMap(([firstKey, firstData]) => {
                if (!isRenderDetail) {
                    let entity = { 'Филиал': firstKey };
    
                    return {
                        ...entity,
                        'Закупка': firstData.invoiceSum || 0,
                        'Закупка %': firstData.invoicePersent,
                        'Сумма': firstData.totalSum,
                        'Закупка к чистой выручке %': firstData.clearSumPersent,
                        'Чистая ыручка': firstData.clearSum,
                    };
                } else {
                    return Object.entries(firstData.orders).flatMap(([secondKey, secondData]) => {
                        const dateText = detail === 'day' ? 'Дата' : 'Период';
                        let entity = { 'Филиал': firstKey, [dateText]: secondKey };
        
                        return {
                            ...entity,
                            'Закупка': secondData.invoiceSum || 0,
                            'Закупка %': secondData.invoicePersent,
                            'Сумма': secondData.totalSum,
                            'Закупка к чистой выручке %': secondData.clearSumPersent,
                            'Чистая ыручка': secondData.clearSum,
                        };
                    });
                }
            });
    
            const result = Object.values(data).reduce((acc, item) => {
                acc.totalSum += item.totalSum || 0;
                acc.invoiceSum += item.invoiceSum || 0;
                acc.clearSum += item.clearSum || 0;
                return acc;
            }, { totalSum: 0, invoiceSum: 0, clearSum: 0 });
        
            const invoicePersent = calculatePercentInvoice(result.totalSum, result.invoiceSum);
            const clearSumPersent = calculatePercentInvoice(result.clearSum, result.invoiceSum);
            
            exportData.push({
                'Филиал': 'ИТОГО',
                'Закупка': result.invoiceSum,
                'Закупка %': invoicePersent,
                'Сумма': result.totalSum,
                'Закупка к чистой выручке %': clearSumPersent,
                'Чистая ыручка': result.clearSum,
            });
    
            const ws = utils.json_to_sheet(exportData);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, 'Закупка');
            const detailText = [];
            const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
            detailText.push(periodText);
            if (isRenderDetail) detailText.push(`Детализация - ${detail.label || '-'}`);
            const resultText = detailText.join(', ');
            writeFileXLSX(wb, `Отчет закупка ${resultText}.xlsx`);
        }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Отношение закупки к продажам
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 250 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={250} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions()}
                            onChange={setDetail}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={detail}                   
                        />
                    </div>
                </div>
            </div>
        );
    }

    const getGroupedData = () => {
        const getFirstKeys = () => {
            const keys = new Set();
            
            if (renderFilters.points && renderFilters.points.length > 0) {
                renderFilters.points.forEach(point => {
                    const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                    if (dataPoint && dataPoint) return keys.add(renderAdress(dataPoint));
                });
            } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                renderFilters.regionalDirectors.forEach((dir) => {
                    if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                        if (point) {
                            let pointId = point.id ? point.id : point;
                            const dataPoint = points.find((point) => point.id === pointId);
                            return keys.add(renderAdress(dataPoint));
                        }
                        keys.add('Филиал не задан');
                    });
                })
            } else {
                result.forEach((order) => {
                    if (order && order.point) return keys.add(renderAdress(order.point));
                    keys.add('Филиал не задан');
                });
            }
            
            return Array.from(keys);
        };
    
        const getDateKeys = () => {
            if (detail.value === 'none') return [];
            
            const startDate = moment(renderFilters.created_at_gte);
            const endDate = moment(renderFilters.created_at_lte);
            const dateKeys = [];

            switch (detail.value) {
                case 'day': {
                    let current = startDate.clone();
                    while (current <= endDate) {
                        dateKeys.push(current.format('DD.MM.YYYY'));
                        current.add(1, 'day');
                    }
                    break;
                }
                case 'week': {
                    let current = startDate.clone().startOf('isoWeek');
                    let end = endDate.clone().endOf('isoWeek');
                    
                    while (current <= end) {
                        let weekStart = current;
                        let weekEnd = current.clone().endOf('isoWeek');

                        if (weekStart < startDate) {
                            weekStart = startDate.format('DD.MM.YYYY');
                        } else {
                            weekStart = weekStart.format('DD.MM.YYYY');
                        }
                        
                        if (weekEnd > endDate) {
                            weekEnd = endDate.format('DD.MM.YYYY');
                        } else {
                            weekEnd = weekEnd.format('DD.MM.YYYY');
                        }

                        dateKeys.push(`${weekStart} - ${weekEnd}`);
                        current.add(1, 'week');
                    }
                    break;
                }
                case 'month': {
                    let current = startDate.clone().startOf('month');
                    let end = endDate.clone().endOf('month');
                    
                    while (current <= end) {
                        const monthStart = current.format('DD.MM.YYYY');
                        const monthEnd = current.clone().endOf('month').format('DD.MM.YYYY');
                        dateKeys.push(`${monthStart} - ${monthEnd}`);
                        current.add(1, 'month');
                    }
                    break;
                }
                default: break;
            }
            
            return dateKeys;
        };
        
        const createData = () => {
            const firstKeys = getFirstKeys();
            const dateKeys = getDateKeys();
            
            const data = {};
            
            firstKeys.forEach(firstKey => {
                const firstData = {
                    name: firstKey,
                    totalSum: 0,
                    clearSum: 0,
                    clearSumPersent: 0,
                    invoiceSum: 0,
                    invoicePersent: 0,
                    orders: {}
                };
                
                if (detail.value !== 'none') {
                    dateKeys.forEach(dateKey => {
                        const dateData = {
                            name: dateKey,
                            totalSum: 0,
                            clearSum: 0,
                            clearSumPersent: 0,
                            invoiceSum: 0,
                            invoicePersent: 0,
                            items: []
                        };
                        
                        firstData.orders[dateKey] = dateData;
                    });
                }
                
                data[firstKey] = firstData;
            });
            
            return data;
        };
        
        const getDateKeyOrders = (order, field) => {
            const time = parseInt(order.timeZone, 10) || 3;
            const baseOrderDate = order.visible_datetime || order.created_at;
            const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
            switch(detail.value) {
                case 'day': {
                    return orderDate.format('DD.MM.YYYY');
                }
                case 'week': {
                    const startDate = moment(renderFilters.created_at_gte);
                    const endDate = moment(renderFilters.created_at_lte);
                    let weekStart = orderDate.clone().startOf('isoWeek');
                    let weekEnd = orderDate.clone().endOf('isoWeek');
    
                    if (weekStart < startDate) {
                        weekStart = startDate.format('DD.MM.YYYY');
                    } else {
                        weekStart = weekStart.format('DD.MM.YYYY');
                    }
                
                    if (weekEnd > endDate) {
                        weekEnd = endDate.format('DD.MM.YYYY');
                    } else {
                        weekEnd = weekEnd.format('DD.MM.YYYY');
                    }
                    
                    return `${weekStart} - ${weekEnd}`;
                }
                case 'month': {
                    const monthStart = orderDate.startOf('month').format('DD.MM.YYYY');
                    const monthEnd = orderDate.endOf('month').format('DD.MM.YYYY');
                    return `${monthStart} - ${monthEnd}`;
                }
                default: {
                    return null;
                }
            }
        };
    
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));

            const invoicesMap = {};
            if (invoices && invoices.length > 0) {
                invoices.forEach((invoice) => {
                    if (invoice.point.id) {
                        if (!invoicesMap[invoice.point.id]) invoicesMap[invoice.point.id] = {};
                        invoicesMap[invoice.point.id][moment(invoice.date).format('DD.MM.YYYY')] = (invoicesMap[invoice.point.id][moment(invoice.date).format('DD.MM.YYYY')] || 0) + (invoice.totalSum || 0);
                    }
                });
            }
            
            const calculateInvoicePeriod = (invoices, dateKey, detailType) => {
                if (!invoices || Object.keys(invoices).length === 0) return 0;
                
                let periodPlan = 0;
                Object.entries(invoices).forEach(([currentDate, sum]) => {
                    const invoiceDate = moment(currentDate, 'DD.MM.YYYY');
                    
                    let inPeriod = false;
                    if (detailType === 'day') {
                        inPeriod = dateKey === currentDate;
                    } else {
                        const [periodStart, periodEnd] = dateKey.split(' - ');
                        const startDate = moment(periodStart, 'DD.MM.YYYY');
                        const endDate = moment(periodEnd, 'DD.MM.YYYY');
                        inPeriod = invoiceDate >= startDate && invoiceDate <= endDate;
                    }
                    
                    if (inPeriod) periodPlan += parseFloat(sum) || 0;
                });
                
                return parseNumToFixed(periodPlan);
            };
            
            const calculateTotalInvoiceForPoint = (pointId) => {
                if (!pointId || !invoicesMap[pointId]) return 0;
                
                const startDate = moment(renderFilters.created_at_gte);
                const endDate = moment(renderFilters.created_at_lte);
                let total = 0;
                
                Object.entries(invoicesMap[pointId]).forEach(([currentDate, value]) => {
                    const invoiceDate = moment(currentDate, 'DD.MM.YYYY');
                    if (invoiceDate >= startDate && invoiceDate <= endDate) total += parseFloat(value) || 0;
                });
                
                return parseNumToFixed(total);
            };

            const calculateAggCommission = (totalPrice, commission, courierId) => {
                const calculateAggCommissionPercent = (sum, persent) => {
                    if (!sum || !persent) return 0;
                    return +parseNumToFixed(persent * 0.01 * sum);
                }

                if (commission.type === 'sum') {
                    if (courierId) return +commission.sum;
                    return +commission.sumAgg;
                }
                
                if (commission.type === 'persent') {
                    if (courierId) return +calculateAggCommissionPercent(totalPrice, commission.persent);
                    return +calculateAggCommissionPercent(totalPrice, commission.persentAgg);
                }

                if (commission.type === 'combined') {
                    if (courierId) return +commission.sum + +calculateAggCommissionPercent(totalPrice, commission.persent);
                    return +commission.sumAgg + +calculateAggCommissionPercent(totalPrice, commission.persentAgg);
                }
            }

            const getSourceOrder = (order) => {
                if (order.aggData && order.aggData.platform) {
                    const platform = platforms.find((source) => source.value === order.aggData.platform);
                    const result = { isAggregator: order.aggData.isAggregator || false, name: order.aggData.platform };
                    if (!isEmpty(platform)) {
                        if (platform.name) result.name = platform.name;
                        if (platform.isAggregator) result.isAggregator = platform.isAggregator;
                        if (platform.commissions) {
                            const entityCommission = platform.commissions.find((commission) => commission.allPoints || commission.pointsIds.includes(+renderFilters.point.value));
                            if (!isEmpty(entityCommission)) result.commission = { sum: +entityCommission.sum || 0,  sumAgg: +entityCommission.sumAgg || 0, type: entityCommission.type, persent: +entityCommission.persent || 0, persentAgg: +entityCommission.persentAgg || 0 };
                        }
                    }
                    return result
                }

                if (order.source && order.source !== 'crm') {
                    const platform = platforms.find((source) => source.value === order.source);
                    if (platform && platform.name) return { isAggregator: platform.isAggregator || false, name: platform.name, commission: platform.commission };
                }

                if (order.source !== 'crm') {
                    if (order.isSite) return { isAggregator: false, name: 'Сайт' };
                    return { isAggregator: false, name: 'Приложение' };
                }
                
                if (order.source === 'crm') {
                    if (order.authorRole) {
                        if ([roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC].includes(order.authorRole)) return { isAggregator: false, name: 'КЦ' };
                        if ([roleId.manager, roleId.cashier, roleId.regionalDirector].includes(order.authorRole)) return { isAggregator: false, name: 'Филиал (магазин)' };
                        if (![roleId.operator, roleId.coordinator, roleId.admin, roleId.directorCC, roleId.manager, roleId.cashier, roleId.operationDirector].includes(order.authorRole)) return { isAggregator: false, name: 'CRM. Принадлежность роли не определена' };
                    }
                }
                
                return { isAggregator: false , name: 'Источник не определен' };
            }
            
            (result || []).forEach((order) => {
                const totalPrice = parseFloat(order.totalPrice) || 0;
                const firstKey = order.point ? renderAdress(order.point) : 'Филиал не задан';
                const pointId = order.point ? order.point.id : null;
                const sourceOrder = getSourceOrder(order);
                
                if (updated[firstKey]) {
                    updated[firstKey].totalSum = parseNumToFixed((parseFloat(updated[firstKey].totalSum) || 0) + totalPrice);
                    updated[firstKey].invoicePersent = calculatePercentInvoice(updated[firstKey].totalSum, updated[firstKey].invoiceSum);

                    if (sourceOrder.isAggregator) {
                        if (!isEmpty(order.aggData) && !isEmpty(order.aggData.commission)) {
                            const commission = calculateAggCommission(order.totalPrice, order.aggData.commission, order.courierId);
                            updated[firstKey].clearSum = parseNumToFixed((parseFloat(updated[firstKey].clearSum) || 0) + (totalPrice - (+commission || 0)));
                            updated[firstKey].clearSumPersent = calculatePercentInvoice(updated[firstKey].clearSum, updated[firstKey].invoiceSum);
                        } else if (!isEmpty(sourceOrder.commission)) {
                            const commission = calculateAggCommission(order.totalPrice, sourceOrder.commission, order.courierId);
                            updated[firstKey].clearSum = parseNumToFixed((parseFloat(updated[firstKey].clearSum) || 0) + (totalPrice - (+commission || 0)));
                            updated[firstKey].clearSumPersent = calculatePercentInvoice(updated[firstKey].clearSum, updated[firstKey].invoiceSum);
                        }
                    } else {
                        updated[firstKey].clearSum = parseNumToFixed((parseFloat(updated[firstKey].clearSum) || 0) + totalPrice);
                        updated[firstKey].clearSumPersent = calculatePercentInvoice(updated[firstKey].clearSum, updated[firstKey].invoiceSum);
                    }

                    if (!updated[firstKey].invoiceSum && pointId) {
                        updated[firstKey].invoiceSum = calculateTotalInvoiceForPoint(pointId);
                        updated[firstKey].invoicePersent = calculatePercentInvoice(updated[firstKey].totalSum, updated[firstKey].invoiceSum);
                        updated[firstKey].clearSumPersent = calculatePercentInvoice(updated[firstKey].clearSum, updated[firstKey].invoiceSum);
                    }
                    
                    if (detail.value !== 'none') {
                        const dateKey = getDateKeyOrders(order);
                        if (dateKey && updated[firstKey].orders[dateKey]) {
                            const dateData = updated[firstKey].orders[dateKey];
                            dateData.totalSum = parseNumToFixed((parseFloat(dateData.totalSum) || 0) + totalPrice);
                            dateData.invoicePersent =  calculatePercentInvoice(dateData.totalSum, dateData.invoiceSum);
                            
                            if (sourceOrder.isAggregator) {
                                if (!isEmpty(order.aggData) && !isEmpty(order.aggData.commission)) {
                                    const commission = calculateAggCommission(order.totalPrice, order.aggData.commission, order.courierId);
                                    dateData.clearSum = parseNumToFixed((parseFloat(dateData.clearSum) || 0) + (totalPrice - (+commission || 0)));
                                    dateData.clearSumPersent = calculatePercentInvoice(dateData.clearSum, dateData.invoiceSum);
                                } else if (!isEmpty(sourceOrder.commission)) {
                                    const commission = calculateAggCommission(order.totalPrice, sourceOrder.commission, order.courierId);
                                    dateData.clearSum = parseNumToFixed((parseFloat(dateData.clearSum) || 0) + (totalPrice - (+commission || 0)));
                                    dateData.clearSumPersent = calculatePercentInvoice(dateData.clearSum, dateData.invoiceSum);
                                }
                            } else {
                                dateData.clearSum = parseNumToFixed((parseFloat(dateData.clearSum) || 0) + totalPrice);
                                dateData.clearSumPersent = calculatePercentInvoice(dateData.clearSum, dateData.invoiceSum);
                            }

                            dateData.items.push(order);
                            
                            if (!dateData.invoiceSum && pointId) {
                                dateData.invoiceSum = calculateInvoicePeriod(invoicesMap[pointId], dateKey, detail.value);
                                dateData.invoicePersent = calculatePercentInvoice(dateData.totalSum, dateData.invoiceSum);
                                dateData.clearSumPersent = calculatePercentInvoice(dateData.clearSum, dateData.invoiceSum);      
                            }
                        }
                    }
                }
            });
            
            Object.keys(updated).forEach((firstKey) => {
                const point = points.find((p) => renderAdress(p) === firstKey);
                if (point && point.id && !isEmpty(KPorogu)) {
                    const entityArticles = KPorogu.filter((article) => article.pointId === point.id);
                    if (!isEmpty(entityArticles)) entityArticles.forEach((article) => {
                        updated[firstKey].clearSum = parseNumToFixed((parseFloat(updated[firstKey].clearSum) || 0) - (+article.sum || 0));
                        if (updated[firstKey]) {
                            const dateKey = getDateKeyOrders(article, 'date');
                            if (updated[firstKey].orders[dateKey]) updated[firstKey].orders[dateKey].clearSum = parseNumToFixed((parseFloat(updated[firstKey].orders[dateKey].clearSum) || 0) - (+article.sum || 0));
                        }
                    });
                }

                if (point && point.id && !updated[firstKey].invoiceSum) {
                    updated[firstKey].invoiceSum = calculateTotalInvoiceForPoint(point.id);
                    updated[firstKey].invoicePersent = calculatePercentInvoice(updated[firstKey].totalSum, updated[firstKey].invoiceSum)
                    updated[firstKey].clearSumPersent = calculatePercentInvoice(updated[firstKey].clearSum, updated[firstKey].invoiceSum);
                }
                
                if (detail.value !== 'none' && updated[firstKey].orders) {
                    Object.keys(updated[firstKey].orders).forEach((dateKey) => {
                        const dateData = updated[firstKey].orders[dateKey];
                        if (point && point.id && !dateData.invoiceSum) {
                            dateData.invoiceSum = calculateInvoicePeriod(invoicesMap[point.id], dateKey, detail.value);
                        }
                    })
                }
            });
            
            return updated;
        };
    
        const data = createData();
        const filledData = fillNullData(data);
        
        return filledData;
    };

    const renderTable = () => {
            const { field, sort } = _sort;
            const data = getGroupedData();
    
            return(
                <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                    <table className='kt-datatable__table' style={{ width: '100%'}}>
                        <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                            <tr className='kt-datatable__row'>
                                <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                    <SortButton
                                    className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Наименование' onClick={() => handleClickSort('name')} 
                                    up={field === 'name' && sort === 'ASC'}
                                    />
                                </th>
                                <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                    <SortButton 
                                    className={field === 'invoiceSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Закупка' 
                                    onClick={() => handleClickSort('invoiceSum')} 
                                    up={field === 'invoiceSum' && sort === 'ASC'}
                                    />
                                </th>
                                <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                    <SortButton 
                                    className={field === 'invoicePersent' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Закупка %' 
                                    onClick={() => handleClickSort('invoicePersent')} 
                                    up={field === 'invoicePersent' && sort === 'ASC'}
                                    />
                                </th>
                                <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                    className={field === 'totalSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Сумма' 
                                    onClick={() => handleClickSort('totalSum')} 
                                    up={field === 'totalSum' && sort === 'ASC'}
                                    />
                                </th>
                                <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                    <SortButton 
                                    className={field === 'clearSumPersent' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Закуп. к выр.' 
                                    onClick={() => handleClickSort('clearSumPersent')} 
                                    up={field === 'clearSumPersent' && sort === 'ASC'}
                                    />
                                </th>
                                <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                    className={field === 'clearSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                    text='Чист. выр.' 
                                    onClick={() => handleClickSort('clearSum')} 
                                    up={field === 'clearSum' && sort === 'ASC'}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody className='kt-datatable__body'>
                            {Object.entries(data)
                            .sort(([aKey, a], [bKey, b]) => {
                                const { field, sort } = _sort;
                                const aField = a[field || 'name'];
                                const bField = b[field || 'name'];
                                if (sort === 'DESC') {
                                    if (typeof aField === 'string') {
                                        if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                        if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                        return 0;
                                    }
                                    return bField - aField;  
                                } else {
                                    if (typeof aField === 'string') {
                                        if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                        if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                        return 0;
                                    }
                                    return aField - bField;                                                        
                                }
                            })
                            .map(([key, item]) => <ItemRow renderPlan={renderFilters.getPlan} item={item} detail={detail}/>)}
                            <ResultRow items={data} renderPlan={renderFilters.getPlan}/>
                        </tbody>
                    </table>
                </div>
            );
        }

    const renderBody = () => {
        if (loading || loader) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="purchase" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}    
            </div> 
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}